<alaris-dialog [closeAction]="close.bind(this)"
			   [confirmAction]="confirm.bind(this)"
			   [loading$]="ratesService.loading$"
			   size="md">
	<h6 slot="header">{{ 'rates.removingDialog' | translate }}</h6>
	<div slot="content">
		<h3><strong>{{ data.rate.currencyName }}</strong></h3>
	</div>
</alaris-dialog>